export function loadImages(query) {
  return [].forEach.call(document.querySelectorAll(query), function (img) {
    img.setAttribute('src', img.getAttribute('data-src'))
    img.onload = function () {
      img.removeAttribute('data-src')
    }
  })
}
